import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// Moduły
import getters from '@/store/getters';
import products from '@/store/modules/products';
import i18n from '@/store/modules/i18n';

Vue.use(Vuex);
const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'veki__products',
      paths: [
        'products'
      ]
    }),
    createPersistedState({
      key: 'veki__i18n',
      paths: [
        'i18n'
      ]
    }),
    // createPersistedState({
    //   key: 'veki__cos',
    //   paths: [
    //     'cos'
    //   ]
    // })
  ],
  modules: {
    products,
    i18n
  },
  getters
});

export default store;